import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  inject,
  input,
  model,
  OnInit,
  TemplateRef,
  Type,
  ViewChild,
} from '@angular/core';
import * as uuid from 'uuid';
import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ModalTypes } from '@core/enums/modal-types';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonComponent } from '@shared/components/button/button.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgComponentOutlet } from '@angular/common';
import { ButtonTypes } from '@core/enums/button-types';
import {NgForm, ValidationErrors} from '@angular/forms';

export class ModalOptions {
  id?: string = uuid.v4();
  type?: ModalTypes;
  title?: string;
  message?: string;
  form?: Type<any> | null;
  formData?: any;
  options?: NgbModalOptions;
  onOk?: () => void;
  onCancel?: () => void;
  onYes?: () => void;
  onNo?: () => void;
  onSave?: () => void;
  onReset?: () => void;
  onShow?: () => void;
  onClose?: () => void;
  formId?: string;
  errors?: ValidationErrors;
  disableOnSave?: boolean;

  constructor(args?: ModalOptions) {
    this.id = args?.id || uuid.v4();
    this.type = args?.type || ModalTypes.confirm;
    this.title = args?.title;
    this.message = args?.message;
    this.form = args?.form;
    this.formData = args?.formData;
    this.options = args?.options;
    this.onOk = args?.onOk;
    this.onCancel = args?.onCancel;
    this.onYes = args?.onYes;
    this.onNo = args?.onNo;
    this.onSave = args?.onSave;
    this.onReset = args?.onReset;
    this.onShow = args?.onShow;
    this.onClose = args?.onClose;
    this.formId = args?.formId;
    this.errors = args?.errors;
    this.disableOnSave = args?.disableOnSave != undefined ? args?.disableOnSave : false;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-modal',
  imports: [
    ButtonComponent,
    //NgComponentOutlet
  ],
  //providers: [ NgbActiveModal ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent implements OnInit, AfterContentChecked, DoCheck {
  private modalService = inject(NgbModal);
  protected modal?: NgbModalRef;
  closeResult = model<string>('');
  private cdref = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('modal');
  protected loading: boolean = false;

  @ViewChild('content') public content!: TemplateRef<any>;

  options = input(new ModalOptions(), {
    transform: (value: ModalOptions) => {
      if (!value) {
        return new ModalOptions();
      }

      return value;
    },
  });

  ngOnInit() {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('modal');
    });
  }

  ngAfterContentChecked(): void {
    //this.cdref.detectChanges();
  }

  ngDoCheck(): void {
    //this.cdref.detectChanges();
  }

  detectChanges(): void {
    this.cdref.detectChanges();
  }

  open() {
    this.modal = this.modalService.open(this.content, {...{
        ariaLabelledBy: 'modal-basic-title',
        beforeDismiss: () => {
          if (this.options().onClose) {
            this.options().onClose?.();
          }
          return true;
        },
        afterDismiss: () => {
          return true;
        },

        ...this.options().options
      }
    });

    this.modal.closed.subscribe(result => {
      if (result) {
        console.log('closed modal', result);
      }
    })

    this.modal.result.then(
      (result) => {
        this.closeResult.set(`Closed with: ${result}`);
        console.log('after dismiss');
        this.options().disableOnSave = false;
      },
      (reason) => {
        this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
      }
    );

    this.modal.shown.subscribe(result => {
      this.options().onShow?.();
      console.log('modal is open ', result);
    })
  }

  close(message?: string) {
    //return modal.dismiss(message || 'Close button pressed');
    this.modal?.close(message);
    this.options().onClose?.();
  }

  onClose = () => {
    this.close('X button pressed');
  };

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  protected onOk = () => {};

  protected onCancel = () => {};

  protected onYes = () => {
    this.options().onYes?.();

    if (!this.options().onYes) {
      this.close('Yes button pressed');
    }
  };

  protected onNo = () => {
    this.options().onNo?.();
  };

  protected onSave = () => {
    this.options().onSave?.();
  };

  protected onReset = () => {
    this.options().onReset?.();
  };

  protected readonly ModalTypes = ModalTypes;
  protected readonly ButtonTypes = ButtonTypes;
  protected readonly Object = Object;
}
